import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { ShortcutHint } from './ShortcutHint';
import * as styles from './SimilarTracksModal.styles';
import type { WhichSongReason, WhichSongSelection } from './types';

interface WhichSongDialogProps {
  open: boolean;
  reason: WhichSongReason | null;
  originalTrackTitle: string;
  originalTrackArtist: string;
  similarTrackTitle: string;
  onClose: () => void;
  onSelect: (selection: WhichSongSelection) => void;
}

const getDialogTitle = (reason: WhichSongReason | null): string => {
  switch (reason) {
    case 'holiday':
      return 'Which song is a holiday song?';
    case 'childrens':
      return "Which song is a children's song?";
    case 'wrong_language':
      return 'Is one of the songs not in English?';
    case 'explicit':
      return 'Which song is explicit?';
    case 'devotional':
      return 'Which song is devotional?';
    default:
      return '';
  }
};

export const WhichSongDialog = ({
  open,
  reason,
  originalTrackTitle,
  originalTrackArtist,
  similarTrackTitle,
  onClose,
  onSelect,
}: WhichSongDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>{getDialogTitle(reason)}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          {reason === 'wrong_language'
            ? 'Please select if one of the songs is not in English, or neither:'
            : 'Please select which song has this issue:'}
        </DialogContentText>
        <Box sx={styles.feedbackButtonsContainer}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelect('original')}
            sx={styles.whichSongButton}
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                {originalTrackTitle}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                by {originalTrackArtist}
              </Typography>
              <ShortcutHint label="1" />
            </Box>
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => onSelect('similar')}
            sx={styles.whichSongButton}
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                {similarTrackTitle}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Similar track
              </Typography>
              <ShortcutHint label="2" />
            </Box>
          </Button>
          {reason === 'wrong_language' && (
            <Button
              variant="outlined"
              fullWidth
              onClick={() => onSelect('neither')}
              sx={styles.whichSongButton}
            >
              <Box>
                <Typography variant="body1" fontWeight={500}>
                  Neither
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Both songs are in English
                </Typography>
                <ShortcutHint label="0" />
              </Box>
            </Button>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
